import "./styles.css";

function Pendente() {
  return (
    <div className="pendenteNotify">
      <span className="notificationsTitle">Chegou a hora!</span>
      <span className="notificationsSubTitle">
        Solicitar <span className="nf">pagamento</span>
      </span>
    </div>
  );
}

export default Pendente;
